import { render, staticRenderFns } from "./InlineBadge.vue?vue&type=template&id=0f804294&"
import script from "./InlineBadge.vue?vue&type=script&lang=js&"
export * from "./InlineBadge.vue?vue&type=script&lang=js&"
import style0 from "./InlineBadge.vue?vue&type=style&index=0&id=0f804294&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports